import React, { useEffect } from 'react';
import '../styles/PrivacyPolicyPage.css';

const PrivacyPolicyPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sections = [
    {
      title: 'Information Collection and Use',
      content:
        'For a better experience while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to your name, phone number, and postal address. The information that we collect will be used to contact or identify you.',
    },
    {
      title: 'Log Data',
      content:
        'We want to inform you that whenever you visit our Service, we collect information that your browser sends to us that is called Log Data. This Log Data may include information such as your computer’s Internet Protocol ("IP") address, browser version, pages of our Service that you visit, the time and date of your visit, the time spent on those pages, and other statistics.',
    },
    {
      title: 'Cookies',
      content:
        'Cookies are files with small amount of data that is commonly used an anonymous unique identifier. These are sent to your browser from the website that you visit and are stored on your computer’s hard drive.Our website uses these "cookies" to collection information and to improve our Service. You have the option to either accept or refuse these cookies, and know when a cookie is being sent to your computer. If you choose to refuse our cookies, you may not be able to use some portions of our Service.',
    },
    {
      title: 'Service Providers',
    content:
      'We may employ third-party companies and individuals due to the following reasons:',
      list: [
        'To facilitate our Service.',
        'To provide the Service on our behalf.',
        'To perform Service-related services.',
        'To assist us in analyzing how our Service is used.',
      ],
      conclusion:
        'We want to inform our Service users that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.',
    },
    {
      title: 'Security',
      content:
        'We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.',
    },
    {
      title: 'Links to Other Sites',
      content:
        'Our Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over, and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.',
    },
    {
      title: 'Children’s Privacy',
      content:
        'Our Services do not address anyone under the age of 8. We do not knowingly collect personal identifiable information from children under 8. In the case we discover that a child under 8 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions.',
    },
    {
      title: 'Changes to This Policy',
      content:
        'We may update our Privacy Policy from time to time. Thus, we advise you to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately, after they are posted on this page.',
    },
  ];

  return (
    <div className="privacyPage">
      <div className="privacyPage-container">
        <div className="privacyPage-header">
          <h1>Privacy Policy</h1>
          <div className="privacyPage-header-underline"></div>
        </div>

        <div className="privacyPage-section privacyPage-intro">
          <p>
            Betaque operates the <span className="privacyPage-highlight">https://betaque.com</span> website, which provides Cloud and DevOps Services.
          </p>
          <p>
            This page is used to inform website visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service.
          </p>
          <p>
          If you choose to use our Service, then you agree to the collection and use of information in relation with this policy. The Personal Information that we collect are used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.
          </p>
        </div>

        <div className="privacyPage-section">
          {sections.map((section, i) => (
            <section key={i} className="privacyPage-section-item">
              <div className="privacyPage-section-title">
                <span className="privacyPage-section-number">{i + 1}</span>
                <h2>{section.title}</h2>
              </div>
              <p className="privacyPage-section-content">{section.content}</p>
              
              {section.list && (
                <ul className="privacyPage-section-list">
                  {section.list.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              )}

              {section.conclusion && (
                <p className="privacyPage-section-content">{section.conclusion}</p>
              )}

            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
